<script>
export default {
    name: "BookOperationModal",

    props: {
        showModal: Boolean,
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-base">Book Operation</h5>
      </template>
      <template v-slot:modal-body>
          <div class="flex flex-wrap -m-2">
              <div class="md:w-1/2 sm:w-full p-tiny">
                  <label for="grid-date" class="label-control">Date:</label>
                  <input type="date" id="grid-date" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/2 sm:w-full p-tiny">
                  <label for="grid-time" class="label-control">Time:</label>
                  <input type="time" id="grid-time" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/2 sm:w-full p-tiny">
                  <label for="grid-surgeon" class="label-control">Surgeon:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select id="grid-surgeon" class="input-control input-sm text-xs">
                              <option value=""></option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/2 sm:w-full p-tiny">
                  <label for="grid-anaesthetist" class="label-control">Anaesthetist:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select id="grid-anaesthetist" class="input-control input-sm text-xs">
                              <option value=""></option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/2 sm:w-full p-tiny">
                  <label for="grid-theatre-room" class="label-control">Theatre Room:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select id="grid-theatre-room" class="input-control input-sm text-xs">
                              <option value=""></option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/2 sm:w-full p-tiny">
                  <label for="grid-assisting-surgeon" class="label-control">Assisting Surgeon:</label>
                  <input type="text" id="grid-assisting-surgeon" class="input-control input-sm text-xs">
              </div>
          </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-4" @click="$emit('closeModal')"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs"><i class="fa fa-save"></i> Save</button>
      </template>
    </tail-modal>
</template>
